import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { navItems } from '@/mocks/videoData';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    navigate(href);
  };

  const isActive = (href: string) => {
    if (href === '/') return location.pathname === '/';
    return location.pathname.startsWith(href);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="flex items-center justify-between px-4 md:px-6 h-16">
        <a
          href="/"
          className="flex items-center gap-2 cursor-pointer"
          onClick={(e) => { e.preventDefault(); navigate('/'); }}
        >
          <span className="w-8 h-8 flex items-center justify-center">
            <i className="ri-play-circle-fill text-2xl" style={{ color: scrolled ? 'oklch(var(--primary-500))' : '#fff' }}></i>
          </span>
          <span
            className={`text-xl font-heading font-semibold whitespace-nowrap transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}
          >
            蘑菇视频
          </span>
        </a>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i
            className={`text-xl transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-white'
            } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
          ></i>
        </button>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
              className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200 ${
                isActive(item.href)
                  ? scrolled
                    ? 'bg-primary-500 text-white'
                    : 'bg-white/20 text-white'
                  : scrolled
                    ? 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                    : 'text-white/80 hover:text-white hover:bg-white/10'
              }`}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`px-4 py-3 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
                  isActive(item.href)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}